import { render, staticRenderFns } from "./layout6-comp1.vue?vue&type=template&id=73194d70&"
import script from "./layout6-comp1.vue?vue&type=script&lang=js&"
export * from "./layout6-comp1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports